import { PropsWithChildren, useState } from 'react';
import classNames from 'classnames';
import { Icon } from '@pwc/pwc-deals-ui';

import './Accordion.scss';

export type AccordionProps = PropsWithChildren<{
  title: string;
  onExpand?: () => void;
  onClose?: () => void;
  width?: number;
  className?: string;
  icon?: React.ReactNode;
  openIcon?: React.ReactNode;
  closedIcon?: React.ReactNode;
}>;

const Accordion = ({
  children,
  title,
  onExpand,
  onClose,
  width = 21,
  openIcon,
  icon,
  closedIcon,
  className = '',
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = classNames(
    'accordion',
    `accordion-${isOpen ? 'open' : 'closed'}`,
    {
      [className]: !!className,
    }
  );

  const defaultIcon = (
    <Icon
      name={isOpen ? 'desc' : 'asc'}
      width={`${width}`}
      className="fill icon-orange-theme accordion-icon"
    />
  );

  const renderIcon = () => {
    if (isOpen) return openIcon || defaultIcon;

    return closedIcon || defaultIcon;
  };

  return (
    <div className={classes} role="listbox">
      <button
        type="button"
        onClick={() => {
          if (!isOpen && typeof onExpand === 'function') {
            onExpand();
          }
          if (onClose) {
            onClose();
          }

          setIsOpen(!isOpen);
        }}
        className="accordion-toggle"
        data-testid="accordion-toggle"
      >
        {icon && <div className="accordion-icon-container">{icon}</div>}
        <span className="accordion-title">{title}</span>
        {renderIcon()}
      </button>
      <div className="accordion-contents">{isOpen && children}</div>
    </div>
  );
};

export default Accordion;
